import { ProductOption } from './types'

export type ShopifyDomain = Readonly<string>
export type ShopifyName = Readonly<string>
export type ShopifyPublicStorefrontToken = Readonly<string>
export type CartKey = Readonly<string>

export enum ShopifyInstanceIdentifierEnum {
  EUR = 'EUR',
  GBP = 'GBP',
  USD = 'USD',
}

export interface ShopifyInstance {
  id: ShopifyInstanceIdentifierEnum // Shopify identifier (e.g., "EUR", "GBP", "USD").
  domain: ShopifyDomain // Shopify domain (e.g., "eur.miista.com", "gbp.miista.com", "usd.miista.com").
  name: ShopifyName // Shopify domain (e.g., "miista-eu", "miistausa", "miista-4").
  isDefault: boolean // Default instance.
  storefrontToken: ShopifyPublicStorefrontToken // Shopify API access token for Storefront API.
  cartKey: CartKey // Cart key for storing in cookies.
}

/**
 * Shopify instances.
 *
 * @see https://admin.shopify.com/store/miista-eu (EUR)
 * @see https://admin.shopify.com/store/miista-4 (GBP)
 * @see https://admin.shopify.com/store/miistausa (USD)
 */
export const shopifyInstances: Readonly<ShopifyInstance[]> = [
  {
    id: ShopifyInstanceIdentifierEnum.EUR,
    domain: 'eur.miista.com',
    name: 'miista-eu',
    isDefault: true,
    storefrontToken: process.env.SHOPIFY_API_ACCESS_TOKEN_EUR!,
    cartKey: 'cartIdEur',
  },
  {
    id: ShopifyInstanceIdentifierEnum.GBP,
    domain: 'gbp.miista.com',
    name: 'miista-4',
    isDefault: false,
    storefrontToken: process.env.SHOPIFY_API_ACCESS_TOKEN_GBP!,
    cartKey: 'cartIdGbp',
  },
  {
    id: ShopifyInstanceIdentifierEnum.USD,
    domain: 'usd.miista.com',
    name: 'miistausa',
    isDefault: false,
    storefrontToken: process.env.SHOPIFY_API_ACCESS_TOKEN_USD!,
    cartKey: 'cartIdUsd',
  },
]

export const getInstanceById = (id: unknown): ShopifyInstance => {
  const instance = shopifyInstances.find((i) => i.id === id)

  if (!instance) {
    throw new Error('Unknown Shopify instance.')
  }

  return instance
}

export const SHOPIFY_HIDDEN_OPTIONS: Readonly<ProductOption['name']>[] = ['Job']
export const SHOPIFY_GRAPHQL_API_ENDPOINT: Readonly<string> = '/api/2025-04/graphql.json'
